import { Pipe, PipeTransform } from '@angular/core';
import { Providers } from 'generated/graphql-types';
import { getProviderDisplayName } from 'src/app/common-components/helpers/provider-helper';

@Pipe({
   name: 'formatProviders',
   standalone: false,
})
export class FormatCallProvidersPipe implements PipeTransform {
   transform(providerId: number | Providers | null | undefined): string {
      return formatProvider(providerId);
   }
}

export function formatProvider(providerId: number | Providers | null | undefined): string {
   return getProviderDisplayName(providerId);
}
